// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","tooltip":"tooltip_tooltip__IxP7a","help":"tooltip_help__Hf8kT","tooltipText":"tooltip_tooltipText__GTIP7","bottom":"tooltip_bottom__NN9+l"};